import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
            <motion.span
                className="block will-change-transform"
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function FadeIn({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, className = "" }) {
    return (
        <p
            className={`font-mono text-[11px] md:text-xs uppercase tracking-[0.35em] text-purp-neon flex items-center gap-3 ${className}`}
        >
            <span className="inline-block w-2 h-2 rounded-full bg-volt animate-pulse-dot" />
            {children}
        </p>
    );
}

export function Tag({ children, tone = "purp" }) {
    const styles =
        tone === "volt"
            ? "border-volt/50 text-volt"
            : tone === "muted"
                ? "border-white/20 text-slate-400"
                : "border-purp/50 text-purp-neon";
    return (
        <span className={`font-mono text-[10px] uppercase tracking-[0.25em] border rounded-full px-3 py-1 ${styles}`}>
            {children}
        </span>
    );
}
